import { styled } from '@material-ui/core/styles'
import { compose, palette, borders, display, flexbox, positions, shadows, sizing, spacing } from '@material-ui/system'

import Grid from '@material-ui/core/Grid'

const GridComponent = styled(Grid)(compose(palette, borders, display, flexbox, positions, shadows, sizing, spacing))

export default GridComponent
